import type { GetGameStampRalliesResponse, GetGameStampRallyResponse } from '@coorum-research/shared-common/api-response/game-stamp-rally.schema'
import http from './http'

export function gameStampRallyApi() {
  async function getGameStampRally(id: string) {
    const response = await http.get<GetGameStampRallyResponse>(`/game-stamp-rallies/${id}`)
    return response.data
  }

  async function getGameStampRallies() {
    const response = await http.get<GetGameStampRalliesResponse>(`/game-stamp-rallies`)
    return response.data
  }

  return {
    getGameStampRally,
    getGameStampRallies,
  }
}
